import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ItemSucursalVentaDiaria from './ItemSucursalVentaDiaria';
const server = process.env.REACT_APP_SERVER;

function ProVentaDiaria() {
    const [regional, setRegional] = useState(JSON.parse(localStorage.getItem('info')).ID_REGIONAL_ACTUAL);
    const [fecha, setFecha] = useState('');
    const [actualizar, setActualizar] = useState(false);
    const [sucursal, setSucursales] = useState([]);
    const [idSucursal, setIdSucursal] = useState(0);
    useEffect(() => {
        var fech = new Date()
        fech.setDate(fech.getDate());
        var mes = parseInt(fech.getMonth()) + 1;
        mes = mes < 10 ? `0${mes}` : mes
        var dia = fech.getDate();
        dia = dia < 10 ? `0${dia}` : dia
        setFecha(fech.getFullYear()+'-'+mes+'-'+dia)
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    //getInformacionProyeccion();
                    console.log(data.ok)
                    setSucursales(data.ok);
                }

            })
            .catch(error => MsgUtils.msgError(error));
    }, [])
    return (
        <>
            <div className='bg-dark bg-gradient container-fluid py-1'>
                <div className='row row-cols gx-1'>
                    <div className='col' style={{ maxWidth: '160px', minWidth: '160px' }}>
                        <div className="input-group input-group-sm">
                            <span className="text-light mx-1 my-auto" >Fecha</span>
                            <input type="date" className="form-control" placeholder="Username" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '120px', minWidth: '120px' }}>
                        <button className='btn btn-sm btn-success w-100' onClick={() => setActualizar(!actualizar)}>
                            <i className="fa-solid fa-magnifying-glass"></i> Cargar</button>
                    </div>
                    <div className='col' style={{ maxWidth: '160px', minWidth: '160px' }}>
                        <div className="input-group input-group-sm" style={{ width: '190px' }}>
                            <span className="text-light mx-1 my-auto" >FILTRAR</span>
                            <select className="form-select form-select-sm" value={idSucursal} onChange={(e) => setIdSucursal(e.target.value)}>
                                <option value={0} selected>TODOS</option>
                                {sucursal.map((item, index) => {
                                    return (
                                        <option value={parseInt(item.ID_SUCURSAL)} key={index}>{item.SUCURSAL}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                </div >
            </div >
            <div className='w-100'>
                <ul className="list-group ">
                    {sucursal.map((item, index) => {
                        if (idSucursal == 0 ? true : idSucursal == item.ID_SUCURSAL) {
                            return (
                                <li className="list-group-item bg-dark m-0 p-0" key={index}>
                                    <ItemSucursalVentaDiaria key={index} sucursal={item} actualizar={actualizar} info={{ regional, fecha }} />
                                </li>
                            )
                        }
                    })}
                </ul>
            </div>
        </>
    )
}

export default ProVentaDiaria